module.exports = {
	"id": "CR",
	"name": "Costa Rica",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.016134,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.010756,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.010756,
			"27": 0.010756,
			"28": null,
			"29": 0.005378,
			"30": null,
			"31": 0.010756,
			"32": 0.021512,
			"33": 0.005378,
			"34": 0.016134,
			"35": 0.010756,
			"36": 0.032268,
			"37": 0.021512,
			"38": 0.048402,
			"39": 0.069914,
			"40": 0.043024,
			"41": 0.032268,
			"42": 0.016134,
			"43": 0.08067,
			"44": 0.064536,
			"45": 0.043024,
			"46": 0.048402,
			"47": 0.091426,
			"48": 0.08067,
			"49": 1.279964,
			"50": 0.129072,
			"51": 0.543178,
			"52": 0.435618,
			"53": 24.690398,
			"54": 6.717122,
			"55": 0.043024,
			"56": 0.005378,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.005378,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.005378,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.010756,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.005378,
			"32": null,
			"33": 0.010756,
			"34": 0.016134,
			"35": 0.02689,
			"36": 0.016134,
			"37": 0.016134,
			"38": 0.059158,
			"39": 0.048402,
			"40": 0.021512,
			"41": 0.043024,
			"42": 0.02689,
			"43": 0.096804,
			"44": 0.043024,
			"45": 0.139828,
			"46": 0.069914,
			"47": 0.419484,
			"48": 0.51091,
			"49": 5.40489,
			"50": 0.064536,
			"51": 0.010756,
			"52": null,
			"3.5": null,
			"3.6": 0.010756
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.069914,
			"28": null,
			"29": 0.096804,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.016134,
			"34": null,
			"35": 0.005378,
			"36": 0.02689,
			"37": 0.198986,
			"38": 0.043024,
			"39": 0.005378,
			"40": 0.338814,
			"41": 0.048402,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.010756
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.037646,
			"6": 0.010756,
			"7": 0.02689,
			"8": 0.290412,
			"9": 0.435618,
			"10": 1.930702,
			"3.1": null,
			"3.2": null,
			"5.1": 0.064536,
			"6.1": 0.075292,
			"7.1": 0.016134,
			"9.1": 1.554242
		},
		"ios_saf": {
			"8": 0,
			"10": 4.2591210458,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.114778383847,
			"8.1-8.4": 0.212048200666,
			"9.0-9.2": 0.101160609492,
			"9.3": 1.5433477602
		},
		"android": {
			"3": 0,
			"4": 0.122644232558,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0153305290698,
			"4.1": 0.442395267442,
			"4.2-4.3": 1.1059881686,
			"4.4": 2.53610752326,
			"4.4.3-4.4.4": 2.55800827907
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.129636866521,
			"9": 0.135038402626,
			"10": 0.145841474836,
			"11": 2.05798525602,
			"5.5": null
		},
		"op_mob": {
			"0": 0.196028387957,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00544523299879
		},
		"edge": {
			"12": 0.102182,
			"13": 0.397972,
			"14": 0.736786
		},
		"ie_mob": {
			"10": 0.116656676056,
			"11": 0.474959323944
		},
		"bb": {
			"7": 0.009244,
			"10": null
		},
		"samsung": {
			"0": 5.532534
		},
		"and_uc": {
			"0": 0.374382
		},
		"op_mini": {
			"0": 2.64105637904
		},
		"and_chr": {
			"0": 25.81852
		},
		"and_ff": {
			"0": 0.02311
		}
	},
	"total": 98.928162
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CR.json
 ** module id = 500
 ** module chunks = 0
 **/